import {
  type Account,
  CloudAccountType,
  Provider,
  AccountState,
} from '@repo/api-gw-sdk';

import dayjs from '@/utils/dayjs';

import { mockDalFactory } from '../../../utils';

const sourceAccountsData: Account[] = [
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b55',
    name: 'AWS prod internal',
    providerAccountId: '905476278391',
    cloudProvider: Provider.Aws,
    role: 'EonSourceAccountRole',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    installedVersion: '1.0.0',
    latestVersion: '1.5.1',
    accountType: CloudAccountType.Source,
    awsOrganizationId: 'org-1',
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b58',
    name: 'AWS prod',
    providerAccountId: '834476278414',
    cloudProvider: Provider.Aws,
    role: 'EonSourceAccountRole',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    installedVersion: '1.0.0',
    latestVersion: '1.5.1',
    accountType: CloudAccountType.Source,
    awsOrganizationId: 'org-1',
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b56',
    cloudProvider: Provider.Azure,
    providerAccountId: '91824f15-b4b8-4148-9aef-e61788c57b4d',
    role: 'Contributor',
    name: 'Azure testing',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    accountType: CloudAccountType.Source,
    awsOrganizationId: 'mg-1',
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b59',
    cloudProvider: Provider.Azure,
    providerAccountId: 'a92261dd-5926-4038-9bea-9b5b5e5c3b59',
    role: 'Contributor',
    name: 'Azure production',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    accountType: CloudAccountType.Source,
    awsOrganizationId: 'mg-1',
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b57',
    cloudProvider: Provider.Gcp,
    providerAccountId: 'platform-prod-302518',
    role: 'eon-service@platform-prod-302518.iam.gserviceaccount.com',
    name: 'GCP Prod',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    accountType: CloudAccountType.Source,
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
  {
    id: 'a92261dd-5926-4038-9bea-9b5b5e5c3b60',
    cloudProvider: Provider.Gcp,
    providerAccountId: 'platform-staging-834957',
    role: 'eon-service@platform-prod-302518.iam.gserviceaccount.com',
    name: 'GCP staging',
    state: AccountState.ACCOUNT_STATE_CONNECTED,
    accountType: CloudAccountType.Source,
    createdTime: dayjs.utc().subtract(1, 'week').toDate(),
  },
];

export const sourceAccountsDAL = mockDalFactory(
  sourceAccountsData,
  (items, demoSettings) =>
    items
      .filter(
        (item) =>
          item.cloudProvider !== Provider.ProviderUnspecified &&
          demoSettings[item.cloudProvider]
      )
      .sort((a, b) => {
        if (
          demoSettings.primaryProvider === a.cloudProvider &&
          demoSettings.primaryProvider === b.cloudProvider
        ) {
          return 0;
        }

        if (demoSettings.primaryProvider === a.cloudProvider) {
          return -1;
        }

        if (demoSettings.primaryProvider === b.cloudProvider) {
          return 1;
        }

        return 0;
      })
);
